import React from 'react'
import { IconSizeType } from './PersonalTouch'

export const Gift2: React.FC<IconSizeType> = ({ width = 56, height = 56 }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_1156_2193)">
        <rect
          x={8}
          y={8}
          width={40}
          height={40}
          rx={4}
          fill="white"
          shapeRendering="crispEdges"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M22.9995 22.2151H20.3744C19.7481 22.2151 19.1661 22.5231 18.7481 22.9429C18.3337 23.359 18 23.9687 18 24.6564V28.0577C18 28.4663 18.3043 28.7976 18.6796 28.7976H19.6948V36.5603C19.6948 37.2482 20.0286 37.8576 20.4432 38.2733C20.8613 38.6928 21.4432 39 22.0691 39H33.9309C34.5568 39 35.1387 38.6928 35.5568 38.2733C35.9714 37.8576 36.3052 37.2482 36.3052 36.5603V28.7976H37.3204C37.6957 28.7976 38 28.4663 38 28.0577V24.6564C38 23.9687 37.6663 23.359 37.2519 22.9429C36.8339 22.5231 36.2519 22.2151 35.6256 22.2151H32.9316C33.0245 22.1532 33.1146 22.0899 33.2017 22.0253C33.8624 21.5352 34.4479 20.8967 34.6664 20.1236C34.7802 19.7212 34.7906 19.2921 34.6648 18.8641C34.5409 18.4426 34.2979 18.066 33.9675 17.7344C32.7647 16.5269 30.9902 16.9601 29.7242 17.9419C28.8622 18.6103 28.0985 19.615 27.6739 20.8429C27.2049 20.0455 26.6543 19.247 26.0541 18.6252C25.5223 18.0743 24.891 17.5979 24.1867 17.4436C23.4344 17.2788 22.6891 17.5017 22.0327 18.1603M26.7906 22.1012C26.3078 21.2222 25.7287 20.3307 25.1171 19.6972C24.6676 19.2314 24.261 18.9693 23.9186 18.8942C23.6243 18.8298 23.3141 18.8868 22.9539 19.2484C22.767 19.4359 22.7017 19.5793 22.6798 19.667C22.6601 19.746 22.6619 19.8311 22.7054 19.9449C22.8087 20.2147 23.126 20.5793 23.7162 20.9574C24.5491 21.4911 25.7012 21.9097 26.7906 22.1012ZM22.9995 22.2151C22.3395 21.7878 21.7222 21.223 21.4508 20.5142C21.3052 20.1339 21.2602 19.7116 21.3681 19.2791C21.4738 18.8554 21.711 18.483 22.0327 18.1603M27.3204 23.6948H20.3744C20.1525 23.6948 19.8871 23.8122 19.6697 24.0305C19.4488 24.2524 19.3592 24.4934 19.3592 24.6564V27.3179H27.3204V23.6948ZM27.3204 28.7976H21.054V36.5603C21.054 36.7231 21.1434 36.9637 21.3642 37.1851C21.5814 37.403 21.8469 37.5203 22.0691 37.5203H27.3204V28.7976ZM28.6796 37.5203V28.7976H34.946V36.5603C34.946 36.7231 34.8566 36.9637 34.6358 37.1851C34.4186 37.403 34.1531 37.5203 33.9309 37.5203H28.6796ZM28.6796 27.3179V23.6948H35.6256C35.8475 23.6948 36.1129 23.8122 36.3303 24.0305C36.5512 24.2524 36.6408 24.4934 36.6408 24.6564V27.3179H28.6796ZM28.7426 22.1731C28.9527 20.8797 29.6648 19.8046 30.5127 19.1471C31.5768 18.322 32.5557 18.3299 33.0461 18.8222C33.2453 19.0222 33.3336 19.1904 33.3703 19.3152C33.4051 19.4336 33.4057 19.5526 33.3674 19.6883C33.2817 19.9914 32.9935 20.3892 32.4363 20.8025C31.5095 21.49 30.1021 22.0238 28.7426 22.1731Z"
          fill="#30B590"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_1156_2193"
          x={0}
          y={0}
          width={56}
          height={56}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation={4} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1156_2193"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_1156_2193"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  )
}
